<template>
    <transition name="fade">
        <div id="del_popup" v-if="isVisible" @click.self="close">
            <div class="welcome">
                <div class="close cursor_1" @click.stop="close"><i class="el-icon-close"
                        style="font-size: 200%;font-weight: bold;"></i></div>
                <div class="left">
                    <img src="@/assets/image/pay/icon.png" />
                </div>
                <div class="right">
                    <p class="title">购买：{{ fromData.title }}</p>
                    <p class="payList">
                    <p class="tips">支付方式</p>
                    <div class="flex-row-center" style="flex-wrap: wrap;padding: 1rem 2rem;">
                        <div class="vip_price2_6 t-m-r-36 " v-for="(item, i) in payList" :key="i"
                            @click="payselect(item)">
                            <img width="12" height="12"
                                :src="payway == item.type ? require('@/assets/image/vip/rideo.png') : require('@/assets/image/vip/rideo1.png')"
                                alt="">
                            <img :width="item.w" :height="item.h" :src="item.img" class="t-m-l-6" />
                            <span class="t-m-l-6">{{ item.name }}</span>
                        </div>
                    </div>
                    </p>
                    
                    <div class="code">
                        <div style="height: 30px;"></div>
                        <p class="tips">支付金额：<span style="color: #FF8719;font-size: 22px;">￥{{ fromData.price }}</span>
                        </p>
                        <p></p>
                        <div class="flex-row-center t-m-t-60">
                            <div class="codeImg"
                                style="height: 140px;width: 140px;border-radius: 6px;overflow: hidden;position: relative;">
                                <div class="loading-qrcode" v-if="!qrcode"
                                    :style="{ background: isShowPayBtn ? 'rgba(0,0,0,0.11)!important' : '#fff' }">
                                    <img v-if="!isShowPayBtn" src="@/assets/image/loading.png" width="60" height="60" />
                                    <div class="play-btn" v-if="isShowPayBtn">
                                        <el-link :underline="false" style="font-size: 18px;" type="primary"
                                            @click.stop="goPay">点击支付</el-link>
                                    </div>
                                </div>

                                <img v-if="payway == 'wx' && qrcode" :src="qrcode" width="100%" height="100%"
                                    style="object-fit: fill;">
                                <iframe scrolling="no" v-if="payway == 'zfb' && qrcode" :srcdoc="qrcode"
                                    class="iframe"></iframe>
                            </div>
                        </div>
                    </div>
                    <div style="text-align: center;" @click="kcxyClick">
                        扫码支付既同意<span class="kcxy cursor_1">《课程协议》</span>
                        <!-- <el-button v-if="!qrcode && isShowPayBtn" type="primary" round :loading="loading" @click.stop="getPay" style="width: 200px;font-size: 16px;">点击支付</el-button> -->
                    </div>
                </div>
            </div>

        </div>
    </transition>
</template>

<script>
import CApi from '@/api/classroom';
import api from '@/api/api'
import data from '@/assets/data';
import QRCode from 'qrcode'
import { sendConvertData } from '@/utils/baidu'
export default {
    props: {
        title: {
            type: String,
            default: '提醒'
        },
        text: {
            type: String,
            default: ''
        },
        confirmText: {
            type: String,
            default: '确认'
        }
    },
    computed: {
        border() {
            if (this.code) {
                return '0px'
            }
            return '1px solid var(--tech-btn-border2)'
        }
    },
    data() {
        return {
            isVisible: false,
            payList: data.pay,
            payway: 'zfb',
            fromData: {},
            qrcode: null,
            status: 0,
            tradeNo: '',
            interval: null, //查询订单结果
            isShowPayBtn: true, //默认true显示点击支付按钮，false表示出现二维码
            loading: false,
            kcxyUrl: 'https://api.esrke.com/rest/novel/public/protocol?type=kcxy&platform=app', //课程协议
        };
    },
    beforeDestroy() {
        this.clear()
    },
    methods: {
        openPrompt(item = {}) {
            this.isVisible = true;
            this.fromData = item
        },
        close() {
            this.isVisible = false;
        },
        confirmSelect() {
            // 处理确认逻辑
            this.isVisible = false;
            localStorage.setItem(this.welcome, true)
            // this.$emit('confirm')
        },
        goPay() {
            this.isShowPayBtn = false
            this.getPay()
        },
        payselect(item) {
            if (this.payway === item.type) return
            this.payway = item.type
            this.isShowPayBtn = true
            this.clear()
            this.qrcode = ''
        },
        createQR(codeUrl) {
            let opts = {
                errorCorrectionLevel: "H",//容错级别type:"image/png",//生成的二维码类型
                quality: 0.3,//二维码质量
            }
            QRCode.toDataURL(codeUrl, opts, (er, url) => {
                console.log('url=', url)
                this.qrcode = url
            })
        },
        clear() {
            // 清除定时器
            if (this.interval) {
                clearInterval(this.interval)
                this.interval = null
            }
        },
        getPay() {
            this.qrcode = null
            this.tradeNo = ''
            this.loading = true
            const params = {
                payType: this.payway,
                id: this.fromData.id
            }
            CApi.payClassroom(params).then((res) => {
                if (res.code === 200) {
                    this.loading = false
                    this.tradeNo = res.data.tradeNo
                    if ('wx' == params.payType) {
                        this.createQR(res.data.codeUrl)
                    } else if ('zfb' == params.payType) {
                        this.qrcode = res.data.zfbParam
                    }
                    this.clear()
                    if (!this.interval) {
                        this.interval = setInterval(() => {
                            api.payStatus(this.tradeNo).then((r) => {
                                if (r.code === 200) {
                                    this.status = r.data
                                    // TODO 支付结果处理
                                    if (-1 == r.data) {
                                        this.clear()
                                        this.$message({
                                            message: '已失效',
                                            type: 'warning',
                                            duration: 3000
                                        })
                                        this.close()
                                    } else if (1 == r.data) {
                                        this.clear()
                                        this.$message({
                                            message: '支付成功',
                                            type: 'success',
                                            duration: 3000
                                        })
                                        const conversionTypes = {
                                            logidUrl: localStorage.getItem('logidUrl'),
                                            newType: 26,
                                            deviceType: 2
                                        }
                                        sendConvertData(conversionTypes).then(res => {
                                            console.log('调用转化成功=', res)
                                            this.close()
                                            this.$router.push({ path: '/classroom_history' })

                                        }).catch((err) => {
                                            console.log('调用转化失败=', err)
                                            this.close()
                                        })

                                    } else if (2 == r.data) {
                                        this.clear()
                                        this.$message({
                                            message: '已取消',
                                            type: 'error',
                                            duration: 3000
                                        })
                                        this.close()
                                    }

                                } else {
                                    this.clear()
                                    this.$message.warning(res.msg)
                                }
                            })
                        }, 1000)
                    }
                }
            }).finally(() => {

            })
        },
        kcxyClick(){
             window.open(this.kcxyUrl)
        }
    }
};
</script>

<style lang="scss" scoped>
p {
    margin: 0;
    padding: 0;
}

#del_popup {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(14, 14, 14, 0.2);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
}


.close {
    position: absolute;
    right: 13px;
    top: 15px;
}

.welcome {
    position: relative;
    display: flex;
    background-color: #FFFFFF;
    width: 54.79%;
    height: 70.76%;
    border-radius: 12px;
}

.left {
    width: 37.36%;
    height: 100%;
    flex-shrink: 0;

    img {
        object-fit: fill;
        width: 100%;
        height: 100%;
    }
}

.right {
    flex: 1;
    height: 100%;
    padding: 0 0 1rem;
    overflow: auto;
    @include scrollbar(none);

    &:hover {
        @include scrollbar_hover()
    }

    .title {
        padding: 4.8% 0 4.8%;
        margin: 0 2rem;
        font-size: 20px;
        font-weight: bold;
        text-align: center;
        border-bottom: 1px solid var(--tech-btn-border2);
    }

    .pay {
        position: absolute;
        bottom: 20px;
    }

    .code {
        padding-bottom: 3.5rem;
    }

    .tips {
        padding: 3rem 2rem;
        font-size: 18px;
        text-align: left;
        position: relative;
        // &::before{
        //     content: ' ';
        //     position: absolute;
        //     left: 0;
        //     top: 25%;
        //     height: 60%;
        //     width: 3px;
        //     border-radius: 3px;
        //     background-color: var(--tech-primary);
        // }
    }
}

.loading-qrcode {
    position: absolute;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .play-btn {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    img {
        animation: rotate .5s linear infinite;
    }

}

.iframe {
    border: 0;
    width: 200px;
    height: 200px;

}

.kcxy {
    color: var(--tech-primary);
}

/* 淡入淡出动画 */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

@media screen and (max-width:1350px) {
    .welcome {
        zoom: 0.8;
    }
}

@media screen and (max-width:1098px) {
    .welcome {
        zoom: 0.6;
    }
}

@media screen and (max-width:960px) and (max-width:746px) {
    .welcome {
        zoom: 0.5;
    }
}

@media screen and (max-width:595px) {
    .welcome {
        zoom: 0.3;
    }
}
</style>